import {
  getObject,
  getString,
  getLeoTimestamp,
  LeoTimestamp,
} from "@surya-digital/leo-ts-types";
import { KeycloakEmail, KeycloakEmailDTO } from "../types/keycloakEmail";

export interface AuditLogDTO {
  emailAddress: KeycloakEmailDTO;
  eventName: string;
  timestamp: string;
}

export class AuditLog {
  readonly isAuditLogAuditLog: boolean = true;

  readonly emailAddress: KeycloakEmail;
  readonly eventName: string;
  readonly timestamp: LeoTimestamp;


  constructor(
  emailAddress: KeycloakEmail, 
  eventName: string, 
  timestamp: LeoTimestamp
  ) {
    this.emailAddress = emailAddress;
    AuditLog.validateEventName(eventName);
    this.eventName = eventName;
    this.timestamp = timestamp;
  }

  static fromDTO(dto: AuditLogDTO): AuditLog {
    const emailAddress = KeycloakEmail.fromDTO(getObject(dto, "emailAddress", InvalidAuditLogEmailAddressError));
    const eventName = getString(dto, "eventName", InvalidAuditLogEventNameError);
    const timestamp = getLeoTimestamp(dto, "timestamp", InvalidAuditLogTimestampError);
    return new AuditLog(
      emailAddress,
      eventName,
      timestamp
    );
  }

  toDTO(): AuditLogDTO {
    const dto: AuditLogDTO = {
        emailAddress: this.emailAddress.toDTO(),
        eventName: this.eventName,
        timestamp: this.timestamp.toDTO()
    };
    return dto;
  }
  private static validateEventName = (eventName: string): void => {
    if(eventName.trim().length === 0) {
      throw new InvalidAuditLogEventNameNonEmptyError(
        `Attribute eventName cannot be an empty string.`
      );
    }
  }
  
}

AuditLog.prototype.toString = function toString(): string {
  return `AuditLog(emailAddress='${this.emailAddress}',eventName='${this.eventName}',timestamp='${this.timestamp}')`;
};

export class InvalidAuditLogError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidAuditLogError";
  }
}
export class InvalidAuditLogEmailAddressError extends InvalidAuditLogError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidAuditLogEmailAddressError";
  }
}

export class InvalidAuditLogEventNameError extends InvalidAuditLogError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidAuditLogEventNameError";
  }
}

export class InvalidAuditLogEventNameNonEmptyError extends InvalidAuditLogEventNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidAuditLogEventNameNonEmptyError";
  }
}

export class InvalidAuditLogTimestampError extends InvalidAuditLogError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidAuditLogTimestampError";
  }
}
